var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrECoGraphicTriangles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1106,
    height: 895,
    viewBox: "0 0 1106 895",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.252534
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1106,
    height: 895
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1106,
    height: 895,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1496 1078V571.701L-524 1078L1496 1078Z",
    fill: "#E6EAEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1496 571.295V-175L862.322 729.54L1496 571.295Z",
    fill: "#EEF1F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1496 1078V571.701L862.328 730.468L619.534 1078H1496Z",
    fill: "#D8DEE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrECoGraphicTriangles);
export default __webpack_public_path__ + "static/media/GrECoGraphicTriangles.380b13688e1ed9980e1ec1f0c1a70d98.svg";
export { ForwardRef as ReactComponent };